module.exports = __webpack_public_path__ + "static/media/slide_3-bg.324bc508.png";